import React from "react";
import { useIntl } from "react-intl";

import AddGroup from "./AddGroup";
import Group from "./Group";

import Carousel from "../../components/carousel/Carousel";
import AddDevice from "../device/AddDevice";
import DevicePreview from "../device/DevicePreview";

import { useDeviceGroupStore } from "../../store/device-group/DeviceGroupStore";
import { useUIState } from "../../store/ui/UIState";

import DeviceInterface from "../../interfaces/DeviceInterface";

import { useThemeStyles } from "../../store/ui/ThemeProvider";
import "./group.scss";

function OtherDevices({ devices }: { devices: DeviceInterface[] }) {
  const { formatMessage } = useIntl();

  if (devices.length === 0) return null;

  return (
    <div className="other-devices">
      <div className="group-title">{formatMessage({ id: "group.other" })}</div>
      {devices.map((device, i) => (
        <DevicePreview key={i} device={device} />
      ))}
    </div>
  );
}

function GroupList() {
  const { groupId } = useUIState();
  const { sectionStyles } = useThemeStyles();
  const { groupStore, deviceStore } = useDeviceGroupStore();

  const otherDevices = React.useMemo(
    () => deviceStore.filter((d) => d.groupId == null),
    [deviceStore]
  );

  const selectedGroupItem = React.useMemo(() => {
    const idx =
      groupId != null ? groupStore.findIndex((g) => g.id === groupId) : 0;
    return idx >= 0 ? idx : groupStore.length;
  }, [groupStore, groupId]);

  return (
    <div className="group-list-wrapper" style={sectionStyles}>
      <Carousel
        className="group-list"
        defaultSelected={selectedGroupItem}
        key={selectedGroupItem}
      >
        {groupStore.map((group, i) => (
          <div key={i} className="group-content">
            <Group group={group} />
            {group.devices.map((device, i) => (
              <DevicePreview key={i} device={device} />
            ))}
            <AddDevice group={group} />
            <OtherDevices devices={otherDevices} />
          </div>
        ))}

        <div className="group-content">
          <AddGroup />
          <OtherDevices devices={otherDevices} />
        </div>
      </Carousel>
    </div>
  );
}

export default GroupList;
